import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';

import {
    userSearchResultGroupsDataSelector,
    userSearchResultGroupsResultSelector,
} from '../../slices/user-search-result-groups.slice';

type Props = {
    groupId: string,
};

export const GroupCell = ({groupId}: Props) => {
    const {isLoading, loadingError} = useSelector(userSearchResultGroupsDataSelector);
    const result = useSelector(userSearchResultGroupsResultSelector);

    const groupName = useMemo(() => result?.data[groupId], [result, groupId]);

    if (isLoading || loadingError || !groupName) {
        return null;
    }

    return (
        <EllipsisTextHint title={groupName}>
            {groupName}
        </EllipsisTextHint>
    );
};
